<template>
  <div class="experience-wrapper--sidebar">
    <section class="wrapper-sidebar--top">
      <LadBeginEndDays />

      <div
        v-scroll-to="{ el: '#experience-wrapper--main-maps', offset: -100 }"
        class="map-navigation-sidebar"
      />
    </section>

    <section v-if="showBtnDates" class="section-joined">
      <div class="wrapper-sidebar--middle d--grid">
        <LadPriceExperienceCustom v-if="showBtnDates && hasPrice" />

        <span>&nbsp;</span>
      </div>
    </section>

    <section v-if="hasHighlights" class="section-joined">
      <LadHighlights />
    </section>

    <section class="wrapper-availability section-joined">
      <el-button v-if="isReserveNowCTA" type="success" @click="handleClick">{{
        $t('general.landings.res_now')
      }}</el-button>

      <el-button v-else-if="isBuyNowCTA" type="success" @click="handleClick">{{
        $t('general.landings.comp_now')
      }}</el-button>

      <el-button
        v-else-if="hasRecommendedAvailability"
        v-scroll-to="{
          el: '#experience-wrapper--main-availability',
          offset: -120,
        }"
        type="success"
        >{{ $t('general.show_availability') }}</el-button
      >

      <el-button v-else-if="showBtnDates" type="success" @click="openModal">{{
        $t('general.show_availability')
      }}</el-button>

      <el-button v-else type="success" @click="handleScroll">{{
        $t('route.i_want_to_quote')
      }}</el-button>
    </section>

    <section class="contact-section">
      <LadTalkFree :base="base" />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CacheComponentMixin from '@/utils/mixin/cache-components'
import LadPriceExperienceCustom from '@/components/pages/experience/partials/price'
import LadBeginEndDays from './components/begin-end-days'

export default {
  name: 'LadSidebarMain',
  components: {
    LadBeginEndDays,
    LadPriceExperienceCustom,
    LadHighlights: () =>
      import(
        /* webpackChunkName: "lad-experience-highlights" */ './components/highlights'
      ),
    LadTalkFree: () =>
      import(
        /* webpackChunkName: "lad-experience-talk-free" */ './components/talk-free'
      ),
  },
  mixins: [CacheComponentMixin],
  data() {
    return {
      base: 'experience.sidebars.main',
      lazy: {
        price: false,
      },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      totalAmount: (state) => state.sales_plan.total_amount,
      hasHighlights: (state) => state.highlights.length > 0,
      promotions: 'promotions',
    }),
    ...mapState('availability', {
      hasAvailability: (state) => state.exist,
      withAvailability: (state) => state.availability.ranges.length > 0,
      hasRecommendedAvailability: (state) => state.hasRecommendedAvailability,
    }),
    hasPrice() {
      return parseFloat(this.totalAmount) > 0
    },
    isReserveNowCTA() {
      return this.$route.query.utm_content === 'res_now'
    },
    isBuyNowCTA() {
      return this.$route.query.utm_content === 'comp_now'
    },
    showBtnDates() {
      return (
        this.totalAmount > 0 && (this.hasAvailability || this.withAvailability)
      )
    },
  },
  methods: {
    handleScroll() {
      this.$scrollTo('.experience-wrapper--container-contact-us')
    },
    async openModal() {
      await this.$store.dispatch('modals/toggle', 'availability')
    },
    contactUrl() {
      this.$router.push({ path: '/contact-us' })
    },
    handleClick() {
      /** Sending event to Facebook */
      if (typeof this.$fb !== 'undefined') {
        this.$fb.trackCustom(this.$route.query.utm_content, {
          event_category: 'utm_content',
          event_label: `CTA with utm_content ${this.$route.query.utm_content}`,
        })
      }

      /** Sending event to Google Analytics */
      if (typeof this.$gtag !== 'undefined') {
        this.$gtag('event', this.$route.query.utm_content, {
          event_category: 'utm_content',
          event_label: `CTA with utm_content ${this.$route.query.utm_content}`,
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }

      this.$router.push({
        name: 'checkout-layaway',
        params: {
          type: 'checkout',
          experience: this.$route.params.permalink,
        },
      })
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--sidebar {
  @media (min-width: 576px) {
    min-width: 380px;
  }

  .wrapper-sidebar--middle {
    grid-template-columns: auto 1fr;
  }

  .wrapper-sidebar--top {
    display: block;
    position: relative;
    z-index: 5;
    padding: 20px 0;

    @media (min-width: 576px) {
      min-width: 360px;
    }

    // @media (min-width: 768px) {
    //   display: none;
    // }

    // @media screen and (max-width: 1026px) {
    //   margin: 0;
    // }

    // @media screen and (max-width: 420px) {
    //   min-width: auto;
    // }
  }

  .map-navigation-sidebar {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    cursor: pointer;
  }

  .goto-more-info {
    margin-top: 20px;
    border-radius: 0;
    text-transform: uppercase;
    text-align: center;

    & > div {
      border-radius: 0 !important;
    }
  }

  section,
  .goto-more-info {
    margin-left: 20px;

    @media screen and (max-width: 1026px) {
      margin-right: 20px;
    }

    @media screen and (max-width: 700px) {
      margin: 0;
    }
  }

  .wrapper-availability {
    padding: 0;
    border: 0;

    .el-button {
      border-radius: 0;
      width: 100%;
      text-transform: uppercase;
      padding: 1.5em 20px;
      border: 0;
    }
  }

  .contact-section {
    margin-top: 0;
    background-color: unset;
  }

  @media screen and (max-width: 1026px) {
    .section-joined,
    .wrapper-availability {
      display: none;
    }
  }
}
</style>
